import React, { Fragment } from "react";

export function Loader() {
  return (
    <Fragment>
      <div className="loader">
        <div className="sub-loader">
          <img
            alt="Promise Shedrach"
            src="/images/p.png"
            className="loader-img"
            width="100"
          />
        </div>
      </div>
    </Fragment>
  );
}
